/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiActionTypeFromJSON, ApiActionTypeToJSON, } from './ApiActionType';
export function ApiFormActionInputFromJSON(json) {
    return ApiFormActionInputFromJSONTyped(json, false);
}
export function ApiFormActionInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'target': !exists(json, 'target') ? undefined : json['target'],
        'targetField': !exists(json, 'targetField') ? undefined : json['targetField'],
        'type': !exists(json, 'type') ? undefined : ApiActionTypeFromJSON(json['type']),
    };
}
export function ApiFormActionInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'target': value.target,
        'targetField': value.targetField,
        'type': ApiActionTypeToJSON(value.type),
    };
}
